(() => {
  const existingBootstrap = window.ChefollaMobileCarouselDots;

  if (existingBootstrap) {
    existingBootstrap.initAll(document);
    return;
  }

  class MobileCarouselDots {
    constructor(root) {
      this.root = root;
      this.track = root.querySelector('[data-mobile-carousel-track]');
      this.items = this.track ? Array.from(this.track.querySelectorAll('[data-mobile-carousel-item]')) : [];
      this.dots = Array.from(root.querySelectorAll('[data-mobile-carousel-dot]'));
      this.animationFrame = null;

      this.handleScroll = () => this.scheduleUpdate();
      this.handleResize = () => this.scheduleUpdate();
      this.handleDotClick = (event) => this.goTo(Number(event.currentTarget.dataset.index));

      this.init();
    }

    init() {
      if (!this.track || this.items.length < 2 || this.dots.length !== this.items.length) return;

      this.track.addEventListener('scroll', this.handleScroll, { passive: true });
      window.addEventListener('resize', this.handleResize, { passive: true });
      this.dots.forEach((dot) => dot.addEventListener('click', this.handleDotClick));
      this.updateActiveIndex();
    }

    goTo(index) {
      const item = this.items[index];
      if (!item || !this.track) return;

      this.track.scrollTo({
        left: item.offsetLeft - this.track.offsetLeft,
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
      });
      this.setActiveIndex(index);
    }

    scheduleUpdate() {
      if (this.animationFrame) return;

      this.animationFrame = window.requestAnimationFrame(() => {
        this.animationFrame = null;
        this.updateActiveIndex();
      });
    }

    updateActiveIndex() {
      if (!this.track || this.items.length === 0) return;

      const targetPosition = this.track.scrollLeft;
      let closestIndex = 0;
      let closestDistance = Number.POSITIVE_INFINITY;

      this.items.forEach((item, index) => {
        const distance = Math.abs(item.offsetLeft - this.track.offsetLeft - targetPosition);
        if (distance < closestDistance) {
          closestDistance = distance;
          closestIndex = index;
        }
      });

      this.setActiveIndex(closestIndex);
    }

    setActiveIndex(activeIndex) {
      this.dots.forEach((dot, index) => {
        const isActive = index === activeIndex;
        dot.classList.toggle('is-active', isActive);
        dot.setAttribute('aria-current', String(isActive));
      });
    }

    destroy() {
      window.cancelAnimationFrame(this.animationFrame);
      this.track?.removeEventListener('scroll', this.handleScroll);
      window.removeEventListener('resize', this.handleResize);
      this.dots.forEach((dot) => dot.removeEventListener('click', this.handleDotClick));
      delete this.root.mobileCarouselDotsInstance;
    }
  }

  function collectRoots(container) {
    const roots = [];
    if (container.matches?.('[data-mobile-carousel]')) roots.push(container);
    roots.push(...(container.querySelectorAll?.('[data-mobile-carousel]') || []));
    return roots;
  }

  function initAll(container) {
    collectRoots(container).forEach((root) => {
      if (!root.mobileCarouselDotsInstance) root.mobileCarouselDotsInstance = new MobileCarouselDots(root);
    });
  }

  function destroyAll(container) {
    collectRoots(container).forEach((root) => root.mobileCarouselDotsInstance?.destroy());
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  document.addEventListener('shopify:section:unload', (event) => destroyAll(event.target));

  window.ChefollaMobileCarouselDots = { initAll, destroyAll };
  initAll(document);
})();
